import _ from "lodash";

export default function get_data_for_pos_neg_lines(in_data_ss) {
  const final_array = _.map(in_data_ss, (d, i) => {
    const arr_data = d.data;
    const elem_id = d.id;
    const elem_name = d.name;
    const sector = d.sector;
    const skew = d.skew;
    const ivPercent = d.ivPercent;
    const eDate = d.eDate;
    const expMove = d.expMove;
    const prevMove = d.prevMove;
    const industry = d.industry;
    const positives = _.map(arr_data, (d) => {
      return {
        ...d,
        y: d.y >= 1.0 ? +d.y - 1.0 : d.y - 1 === 0 ? d.y - 1 : null
      };
    });
    const negatives = _.map(arr_data, (d) => {
      return { ...d, y: d.y < 1.0 ? d.y - 1 : d.y - 1 === 0 ? null : d.y - 1 };
    });
    debugger;

    const return_arr = [];
    return_arr.push({
      symbol: elem_id,
      id: "possitives",
      name: elem_name,
      data: positives,
      sector: sector,
      industry: industry,
      skew: skew,
      ivPercent: ivPercent,
      eDate: eDate,
      expMove: expMove,
      prevMove: prevMove
    });

    return_arr.push({
      symbol: elem_id,
      id: "negatives",
      name: elem_name,
      data: negatives,
      sector: sector,
      industry: industry
    });
    return return_arr;
  });
  return final_array;
}
